const userList = {
    userLists: [],
    activeUserList: {},
    busy: false,
    usersBusy: false,
    users: [],
    userListsHasMore: true,
    usersHasMore: true,
    userListsPage: 1,
    usersPage: 1,
    userListsTotal: 0,
    usersTotal: 0,
    userListModal: false,
};

export default userList;
